var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-navigation-drawer'),_vm._v(" "),_c('my-filters-panel'),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('my-clientes-datatable'),_vm._v(" "),_c('my-eventbus')],1)}
var staticRenderFns = []

export { render, staticRenderFns }